import { reactive } from 'vue';
import * as storage from './storage';

const state = reactive({
  permissions: JSON.parse(storage.get('permissions') || '[]')
});

export function setPermissions(permissions) {
  state.permissions = Array.isArray(permissions) ? permissions : [];
  storage.set('permissions', JSON.stringify(state.permissions));
}

export function clearPermissions() {
  state.permissions = [];
  storage.remove('permissions');
}

export function getPermissions() {
  return state.permissions;
}

export function hasPermission(permission) {
  if (!permission) return true;
  if (Array.isArray(permission)) {
    if (permission.length === 0) return true;
    return permission.some(p => state.permissions.includes(p));
  }
  return state.permissions.includes(permission);
}

export const vPermission = {
  mounted(el, binding) {
    if (!binding.value) return;
    if (!hasPermission(binding.value)) {
      hideElement(el);
    }
  },
  updated(el, binding) {
    if (!binding.value) return;
    if (hasPermission(binding.value)) {
      showElement(el);
    } else {
      hideElement(el);
    }
  }
};

function hideElement(el) {
  el._permission_display = el.style.display;
  el.style.display = 'none';
  el.setAttribute('data-permission-hidden', 'true');
}

function showElement(el) {
  if (el._permission_display !== undefined) {
    el.style.display = el._permission_display;
  } else {
    el.style.display = '';
  }
  el.removeAttribute('data-permission-hidden');
}